/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import clsx from "clsx";
import BookingLoginReservationDetailButton
    from "pages/Front/Booking/BookingLogin/components/BookingLoginReservationDetail/components/BookingLoginReservationDetailButton";
import {ReceiptPercentIcon, TrashIcon} from "@heroicons/react/24/solid";
import {PackagesCartItemVoucher} from "types/entities/PackagesCartItemVoucher";
import {useTranslation} from "react-i18next";
import {useDispatch} from "useDispatch";
import AlertConfirmation from "pages/Front/Registration/components/AlertConfirmation";
import {openModal} from "helpers/actions";
import {ModalSize} from "pages/Front/components/Popup";
import {Reservation} from "types/entities/Reservation";
import BookingSellerVoucherModal
    from "pages/Front/Booking/Seller/BookingSellerReservationDetail/components/BookingSellerVoucherModal";
import {toast} from "react-toastify";
import SellerAction from "store/seller/SellerAction";

interface BookingSellerReservationDetailVoucherActionsProps {
    className?: string;
    packagesCartItemVoucher: PackagesCartItemVoucher;
    reservation: Reservation;
}

const BookingSellerReservationDetailVoucherActions = (props: BookingSellerReservationDetailVoucherActionsProps) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const onRemoveHandler = (packagesCartItemVoucher: PackagesCartItemVoucher) => {
        AlertConfirmation({
            message: t("You are about to remove an voucher, only admin can reverse this."),
            onClick: () => onConfirmRemoveHandler(packagesCartItemVoucher),
            title: t("Remove voucher"),
        });
    };

    const onConfirmRemoveHandler = (packagesCartItemVoucher: PackagesCartItemVoucher) => {
        dispatch(SellerAction.fetchDeleteVoucher(props.reservation.id, packagesCartItemVoucher.voucher_id)).then(r => {
            toast.warn(t("Voucher deleted"));
            // dispatch(SellerAction.setReservation(r.reservation));
        });
    };

    const onDiscountHandler = (packagesCartItemVoucher: PackagesCartItemVoucher) => {
        dispatch(
            openModal(<BookingSellerVoucherModal packagesCartItemVoucher={packagesCartItemVoucher}
                                                 reservation={props.reservation} />, {
                modalSize: ModalSize.Scrollable,
            }),
        );
    };

    return (
        <div
            className={clsx("BookingSellerReservationDetailVoucherActions flex flex-row justify-center gap-x-2", props.className)}>
            <BookingLoginReservationDetailButton
                className={"border-purple-400 bg-purple-400 h-[30px]"}
                onClick={() => onDiscountHandler(props.packagesCartItemVoucher)}
            >
                <ReceiptPercentIcon className={"w-4 h-4 flex-none"} />
            </BookingLoginReservationDetailButton>
            <BookingLoginReservationDetailButton
                className={"border-red-400 bg-red-400 h-[30px]"}
                onClick={() => onRemoveHandler(props.packagesCartItemVoucher)}
            >
                <TrashIcon className={"w-4 h-4 flex-none"} />
            </BookingLoginReservationDetailButton>
        </div>
    );
};

export default BookingSellerReservationDetailVoucherActions;
